export const SpinSelect = ({ value, onChange, spins, matches, common }) => {
    const matchIds = new Set(matches.map((s) => s.id));
    const others = spins.filter((s) => !matchIds.has(s.id));
    const opt = (s) => <option key={s.id} value={s.id}>{`${s.name} — ${s.city}`}</option>;
    return (
        <select className="edi-input" value={value || ""} onChange={(e) => onChange(e.target.value)} {...common}>
            <option value="">Seleziona uno sportello…</option>
            {matches.length > 0 ? (
                <>
                    <optgroup label="Sportelli della tua provincia">{matches.map(opt)}</optgroup>
                    <optgroup label="Altri sportelli SPIN">{others.map(opt)}</optgroup>
                </>
            ) : (
                <optgroup label="Tutti gli sportelli SPIN">{spins.map(opt)}</optgroup>
            )}
        </select>
    );
};

export const SpinCard = ({ spin }) => {
    if (!spin) return null;
    return (
        <div className="rounded-lg border-l-4 border-edi-lime bg-edi-lime-soft p-4" data-testid="spin-card">
            <p className="font-heading font-bold text-lg" data-testid="spin-card-name">{spin.name}</p>
            <p data-testid="spin-card-address">{spin.address}, {spin.cap} {spin.city}</p>
            {spin.phone && <p>Telefono: <a href={`tel:${spin.phone.replace(/\s/g, "")}`} data-testid="spin-card-phone">{spin.phone}</a></p>}
            {spin.email && <p className="break-all">Email: <a href={`mailto:${spin.email}`} data-testid="spin-card-email">{spin.email}</a></p>}
        </div>
    );
};
